module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei8.svg";